import { useState } from 'react'
import { Link, useNavigate, useSearchParams } from 'react-router-dom'
import { useCustomAuth } from '@/hooks/useCustomAuth'
import { Button } from '@/components/ui/button'
import { Input } from '@/components/ui/input'
import { Label } from '@/components/ui/label'

const Login = () => {
  const [searchParams] = useSearchParams()
  const navigate = useNavigate()
  const { handleSignIn, loading } = useCustomAuth()
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')

  // Check if user just confirmed their email
  const confirmed = searchParams.get('confirmed') === 'true'

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault()
    const success = await handleSignIn(email, password)
    if (success) {
      navigate('/dashboard')
    }
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-[radial-gradient(ellipse_at_top,_var(--tw-gradient-stops))] from-black via-[#111] to-[#0a0a0a] p-6">
      <div className="w-full max-w-md">
        <div className="rounded-2xl border border-white/10 bg-white/5 backdrop-blur-xl shadow-[0_10px_40px_rgba(0,0,0,0.35)] p-6 sm:p-8">
          <div className="text-center mb-6">
            <div className="flex items-center justify-center mb-2">
              <img
                src="/dablylogofulltext-transparent.png"
                alt="Dably"
                className="h-12 w-auto drop-shadow-[0_4px_24px_rgba(99,102,241,0.35)]"
                loading="eager"
              />
            </div>
            {confirmed && (
              <div className="mt-4 p-3 rounded-md bg-emerald-500/10 text-emerald-300 border border-emerald-500/30">
                ✨ Email confirmed! You can now sign in.
              </div>
            )}
          </div>

          <form onSubmit={handleSubmit} className="space-y-5">
            <div className="space-y-2">
              <Label htmlFor="email" className="text-white/80">Email</Label>
              <Input
                id="email"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="you@university.edu"
                required
                disabled={loading}
                className="bg-black/30 border-white/10 text-white placeholder:text-white/40 focus-visible:ring-purple-400"
              />
            </div>

            <div className="space-y-2">
              <div className="flex justify-between items-center">
                <Label htmlFor="password" className="text-white/80">Password</Label>
                <Link
                  to="/auth/forgot-password"
                  className="text-sm text-purple-300 hover:text-purple-200"
                >
                  Forgot password?
                </Link>
              </div>
              <Input
                id="password"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Enter your password"
                required
                disabled={loading}
                className="bg-black/30 border-white/10 text-white placeholder:text-white/40 focus-visible:ring-purple-400"
              />
            </div>

            <Button
              type="submit"
              className="w-full bg-purple-500 hover:bg-purple-400 text-white shadow-[0_6px_30px_rgba(139,92,246,0.4)]"
              disabled={loading}
            >
              {loading ? 'Signing in...' : 'Sign in'}
            </Button>
          </form>

          <p className="text-center text-sm text-white/60 mt-5">
            Dont have an account?{' '}
            <Link to="/signup" className="text-purple-300 hover:text-purple-200 font-medium">
              Sign up
            </Link>
          </p>
        </div>
      </div>
    </div>
  )
}

export default Login 